import { render, staticRenderFns } from "./app-role-edit.vue?vue&type=template&id=51ecb417&scoped=true&"
import script from "./js/app-role-edit.js?vue&type=script&lang=js&"
export * from "./js/app-role-edit.js?vue&type=script&lang=js&"
import style0 from "./app-role-edit.vue?vue&type=style&index=0&id=51ecb417&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ecb417",
  null
  
)

export default component.exports